<nb-action
  nbTooltip="System Health Notifications"
  nbTooltipPlacement="bottom"
  class="control-item health-check-messages-button"
  (click)="toggleVisibility()"
  badgeStatus="warning"
  badgePosition="bottom right"
  [badgeText]="unreadCnt > 0 ? unreadCnt.toString() : ''"
  icon="activity-outline"
  style="padding: 0 !important"
>
</nb-action>

<div class="user-notifications-panel" [ngClass]="{ visible: isVisible }">
  <div class="background" (click)="toggleVisibility()"></div>
  <div class="divider"></div>
  <nb-card class="content">
    <nb-card-header class="content-caption">
      <h5>
        {{ caption }}
        @if (isAdmin()) {
          <a
            pButton
            routerLink="admin/health-check/notifications"
            class="p-button-outlined p-button-icon-only text-hint"
            title="Open Health Check Messages Page"
          >
            <i class="material-icons">open_in_new</i>
          </a>
        }
      </h5>

      <button
        pButton
        class="p-button-outlined p-button-icon-only text-hint"
        type="button"
        (click)="toggleVisibility()"
      >
        <i class="material-icons">close</i>
      </button>
    </nb-card-header>
    <nb-card-body>
      <ng-container *cdkLet="notifications$ | async as notifications">
        @for (notification of notifications; track notification) {
          <div>
            <ng-template
              [ngTemplateOutlet]="templateRef"
              [ngTemplateOutletContext]="createContext(notification)"
            ></ng-template>
          </div>
        }

        @if (!notifications?.length) {
          <div class="no-notifications">There are no messages</div>
        }
      </ng-container>
    </nb-card-body>
  </nb-card>
</div>
